export default "__VITE_ASSET__$koXCPqG__"